import React from 'react';

interface ConsentLGPDCheckboxProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  required?: boolean;
}

export default function ConsentLGPDCheckbox({ checked, onChange, required = false }: ConsentLGPDCheckboxProps) {
  return (
    <label className="checkbox-label">
      <input
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        required={required}
      />
      <span>
        Concordo com a{' '}
        <strong>Política de Privacidade e Proteção de Dados (LGPD)</strong>. Entendo que meus dados serão
        tratados de acordo com a Lei Geral de Proteção de Dados Pessoais (Lei nº 13.709/2018).
      </span>
    </label>
  );
}
